/* eslint-disable */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import { arrayOf, bool, func, oneOfType, number, string, shape } from 'prop-types';
import isEqual from 'lodash/isEqual';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel/container/index.async';
import { breakpoints } from '@tcp/core/styles/themes/TCP/mediaQuery';
import Heading from '@tcp/core/src/components/common/atoms/Heading';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import ButtonCTA from '@tcp/core/src/components/common/molecules/ButtonCTA';
import {
  getIconPath,
  getViewportInfo,
  isClient,
  getSessionStorage,
  setSessionStorage,
  getSFCCClass,
} from '@tcp/core/src/utils';
import { capitalizeWords } from '@tcp/core/src/utils/utils';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import CarouselContainer from '@tcp/core/src/components/common/molecules/Carousel/container/Carousel.container';
import RecommendationCarousel from '@tcp/core/src/components/common/molecules/RecommendationCarousel';
import TrendingInCategoryRecommendations from '@tcp/core/src/components/features/browse/CategoryListingPage/molecules/TrendingInCategoryRecommendations';
import LazyLoadHOC from '@tcp/web/src/components/common/hoc/LazyLoad/LazyLoadNew';
import ModuleO from '@tcp/core/src/components/common/molecules/ModuleO';
import ModuleP from '@tcp/core/src/components/common/molecules/ModuleP';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels.js';
import { getPlpLabelsCopy } from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.selectors.js';
import config from '../container/config';
import constant from '../container/Recommendations.constants';
import style, {
  RecommendationCol,
  ButtonDiv,
  Button,
  RecommendationUl,
  RecommendationLi,
  RecommendationMultiUl,
  RecommendationMultiLi,
  RecommendationMultiGridHeader,
} from '../styles/Recommendations.style';
import RecommendationSkeleton from './RecommendationSkeleton.view';
import { getLabelsProductListingCopy } from '../container/Recommendations.selector';

const RecomStyleWith = dynamic(() =>
  import(
    /* webpackChunkName: "recomStyleWith" */ '@tcp/core/src/components/common/molecules/RecomStyleWith'
  )
);

const RecomFBT = dynamic(() =>
  import(/* webpackChunkName: "recomFBT" */ '@tcp/core/src/components/common/molecules/RecomFBT')
);

const productsLength = isClient() && getViewportInfo().isMobile ? 3 : 4;
let viewProducts = 8;
if (isClient() && (getViewportInfo().isMobile || getViewportInfo().isTablet)) viewProducts = 6;
/**
 * This method loads different variations for Recommendation Module dynamically
 */
const RecommendationComponentVariation = (dynamicComponentProps) => {
  switch (dynamicComponentProps.variation) {
    case config.variations.moduleO:
      return <ModuleO {...dynamicComponentProps} />;
    case config.variations.moduleP:
      return <ModuleP {...dynamicComponentProps} />;
    default:
      return <ModuleO {...dynamicComponentProps} />;
  }
};

const isShowHeader = (isFavoriteRecommendation, isSuggestedItem, accordionHeader, portalValue) => {
  return (
    !isFavoriteRecommendation &&
    !isSuggestedItem &&
    !accordionHeader &&
    portalValue !== Constants.RECOMMENDATIONS_MBOXNAMES.IN_GRID_PLP_PRODUCTS
  );
};

const { RECOMMENDATION } = constant;

class Recommendations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAccordionOpen: false,
      isRecoHeightSmall: false,
      showProducts: [],
      viewMoreProducts: [],
      showPdpProducts: 0,
    };
    this.handleAccordionToggle = this.handleAccordionToggle.bind(this);
    this.handleRecosHeightToggle = this.handleRecosHeightToggle.bind(this);
    this.plpLabelsObj = getLabelFromCopyOrFromTranslation('PLP', PLPLabels);
    this.labels = getLabelsProductListingCopy(this.plpLabelsObj);
    this.plpLabels = getPlpLabelsCopy(this.plpLabelsObj);
  }
  componentDidMount() {
    const {
      loadRecommendationsAdobe,
      loadRecommendationsMonetate,
      portalValue,
      partNumber,
      categoryName,
      reduxKey,
      excludedIds,
      provider = 'Monetate',
      MONETATE_ENABLED,
      cartItems,
      isOutfitLoading,
      outfitItems,
      userEmail,
      addedToBagData,
      pdpDataInformation,
      styleWithEligibility,
      isPlcc,
      outOfStock,
      isFBTEnabled,
      isNoResponseRecommendation,
      categoryFilterArray,
      isRecommendationProductInfoEnabled,
      birthdayDepartment,
      primaryBrand,
      loadedProductCount,
      products,
      fromBIACarousel,
      primaryCategory,
      productIds,
    } = this.props;

    let { page } = this.props;
    const skuData = this.skuDetail(addedToBagData, pdpDataInformation);
    if (page === 'home page') page = 'homepage';

    let action = {
      page: page || 'homepageTest',
      ...(partNumber && { itemPartNumber: partNumber }),
      categoryName: categoryName || '',
      excludedIds,
      provider,
      MONETATE_ENABLED,
      cartItems,
      outfitItems,
      userEmail,
      skuData,
      styleWithEligibility,
      isPlcc,
      outOfStock,
      isFBTEnabled,
      isNoResponseRecommendation,
      categoryFilterArray,
      primaryBrand,
      birthdayDepartment,
      primaryCategory,
      productIds,
    };

    if (reduxKey === 'favorites_global_products') {
      action.reduxKey = reduxKey;
    } else if (!MONETATE_ENABLED) {
      action.reduxKey = reduxKey;
      action = { ...action, ...(portalValue && { mboxName: portalValue }) };
    } else {
      action.reduxKey = action.page;
    }

    if (window.adobe && window.adobe.target) {
      return loadRecommendationsAdobe(action);
    }
    if (!(page === 'outfit' && isOutfitLoading)) {
      if (fromBIACarousel && products?.length > 0) return;
      return window.addEventListener('load', loadRecommendationsMonetate(action));
    }

    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (isEqual(nextProps, this.props) && isEqual(nextState, this.state)) {
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const {
      loadRecommendationsMonetate,
      partNumber,
      categoryName,
      excludedIds,
      provider = 'Monetate',
      MONETATE_ENABLED,
      cartItems,
      isBagLoading,
      isOutfitLoading,
      outfitItems,
      userEmail,
      addedToBagData,
      pdpDataInformation,
      styleWithEligibility,
      outOfStock,
      isNoResponseRecommendation,
      categoryFilterArray,
      updateShowRecentlyViewedVertically,
      portalValue,
      birthdayDepartment,
      primaryCategory,
      isFBTEnabled,
      productIds,
      orderDetailsRecommendationsEnabled,
    } = this.props;

    const { page } = this.props;
    const skuData = this.skuDetail(addedToBagData, pdpDataInformation);
    const action = {
      page: page || 'homepageTest',
      ...(partNumber && { itemPartNumber: partNumber }),
      categoryName: categoryName || '',
      excludedIds,
      provider,
      MONETATE_ENABLED,
      cartItems,
      outfitItems,
      userEmail,
      skuData,
      styleWithEligibility,
      outOfStock,
      isFBTEnabled,
      isNoResponseRecommendation,
      categoryFilterArray,
      birthdayDepartment,
      primaryCategory,
      productIds,
    };

    action.reduxKey = action.page;
    if (
      typeof updateShowRecentlyViewedVertically === 'function' &&
      prevProps.products !== this.props.products &&
      portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED &&
      this.props.products?.length > 0
    ) {
      updateShowRecentlyViewedVertically();
    }

    if (
      !(page === 'cart' && isBagLoading) &&
      !(page === 'outfit' && isOutfitLoading) &&
      (prevProps.isNoResponseRecommendation !== isNoResponseRecommendation ||
        prevProps.isBagLoading !== this.props.isBagLoading ||
        (this.props.isTrendingInCategoryRecommendations &&
          prevProps.primaryCategory !== primaryCategory) ||
        (orderDetailsRecommendationsEnabled && prevProps.productIds !== productIds))
    ) {
      return window.addEventListener('load', loadRecommendationsMonetate(action));
    }
    return null;
  }

  componentWillUnmount() {
    const { loadRecommendationsMonetate } = this.props;
    window.removeEventListener('load', loadRecommendationsMonetate);
  }

  skuDetail = (addedToBagData, pdpDataInformation) =>
    addedToBagData && addedToBagData.skuInfo ? addedToBagData.skuInfo : pdpDataInformation;

  isPromoAvailable = (products) =>
    products.map((product) => product.productInfo && product.productInfo.promotionalMessage);

  getRecoHeightStatus = (isRecoHeightSmall) => {
    return isRecoHeightSmall ? '' : 'small-recos-height';
  };

  getAccordionClass = (isAccordionOpen) => {
    return isAccordionOpen ? 'show-accordion-toggle' : '';
  };

  haveStyleWithProducts = (styleWithView, products) =>
    styleWithView && products?.length && products[0].styleWithEligibility;

  haveFBTProducts = (isFBT, products) => isFBT && products?.length && products[0].isFbt;

  showMoreProducts = () => {
    const { products, portalValue } = this.props;
    const { showProducts } = this.state;
    let count = showProducts?.length + viewProducts;
    if (products?.length <= viewProducts) {
      count = products?.length;
    }

    const value =
      portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED
        ? getSessionStorage('PDP2')
        : getSessionStorage('PDP1');

    if (
      value > 0 &&
      isClient() &&
      getSessionStorage('LAST_PAGE_PATH') === window.location.pathname
    ) {
      count = value;
      this.setState({ showPdpProducts: count });
      if (portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED)
        setSessionStorage({ key: 'PDP2', value: 0 });
      else setSessionStorage({ key: 'PDP1', value: 0 });
    }

    this.setState({
      showProducts: products.slice(0, count),
    });
  };

  showMoreButton = () => {
    const buttonTxt = `VIEW MORE`;
    return (
      <ButtonDiv>
        <Button onClick={() => this.showMoreProducts()}>{buttonTxt}</Button>
      </ButtonDiv>
    );
  };

  showRecosBannerExperience = (recommendationBannerHTML) => {
    return <div dangerouslySetInnerHTML={{ __html: recommendationBannerHTML }} />;
  };

  bannerRecommendationForScrolling = (page, recommendationBannerHTML, LoadVariation) => {
    return (
      <div className="smooth-scroll-list">
        <ul className="smooth-scroll-list-item">
          <li className="product-list">
            <div className="bannerStyles">
              {this.showRecosBannerExperience(recommendationBannerHTML)}
            </div>
          </li>
        </ul>
        {LoadVariation}
      </div>
    );
  };

  loadInMultiGridPlpRecommendation = (variation) => {
    const { products, index, slots, slotsList, portalValue } = this.props;
    const label =
      portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.IN_GRID_PLP_PRODUCTS
        ? getDynamicLabelValues('dynamic.browse_d.lbl_plp_in_grid_header')
        : this.labels.inMultiGridHeader;

    let currentRecosProduct = [];
    let pos = 0;
    let productId = '';
    if (slots && slots[0]?.length > 0) {
      let len = 0;
      pos = slotsList.toString().indexOf(index);
      slots.forEach((slot) => {
        if (index === slot[0]) {
          len = slot[1] - slot[0] + 1;
        }
      });
      currentRecosProduct =
        products.slice(pos, pos + len)?.length === len
          ? products.slice(pos, pos + len)
          : products.slice(0, len);
    } else {
      pos = slots.toString().indexOf(index);
      if (pos === -1 || typeof products[pos] === 'undefined') pos = 0;
      currentRecosProduct = products[pos];
      const { generalProductId } = currentRecosProduct;
      productId = generalProductId;
    }

    return (
      <React.Fragment>
        <RecommendationMultiGridHeader>{label}</RecommendationMultiGridHeader>
        <RecommendationMultiUl>
          {slots[0]?.length > 0 ? (
            currentRecosProduct.map((product, i) => {
              const { generalProductId } = product;
              return (
                <RecommendationMultiLi
                  className="multi-grid-product-tile"
                  key={`recommended_products_li_${variation}_${generalProductId}`}
                >
                  {this.loadRecommendationVariation(
                    variation,
                    product,
                    pos + i,
                    'in-multi-grid-plp'
                  )}
                </RecommendationMultiLi>
              );
            })
          ) : (
            <RecommendationMultiLi
              className="multi-grid-product-tile"
              key={`recommended_products_li_${variation}_${productId}`}
            >
              {this.loadRecommendationVariation(
                variation,
                currentRecosProduct,
                pos,
                'in-multi-grid-plp'
              )}
            </RecommendationMultiLi>
          )}
        </RecommendationMultiUl>
      </React.Fragment>
    );
  };

  loadBannerRecommendation = (variation, carouselProps, customProductsLength) => {
    const isMobile = isClient() ? getViewportInfo().isMobile : null;
    const isTablet = isClient() ? getViewportInfo().isTablet : null;
    const { page, recommendationBannerHTML, products, isNoResponseRecommendation } = this.props;
    const LoadVariation = this.loadVariation(variation, 'smooth-scroll-list-item');
    const CarouselVariation = 'big-arrows';
    const CarouselcustomArrowLeft = getIconPath('carousel-big-carrot-left');
    const CArouselcustomArrowRight = getIconPath('carousel-big-carrot');
    if (isMobile || isTablet) {
      return this.bannerRecommendationForScrolling(page, recommendationBannerHTML, LoadVariation);
    }

    const carProps =
      products?.length <= customProductsLength
        ? { ...carouselProps, infinite: false }
        : carouselProps;

    return (
      <React.Fragment>
        <Row>
          <Col className="recommendation-banner" colSize={{ small: 2, medium: 2, large: 2.5 }}>
            <div className="bannerStyles">
              {this.showRecosBannerExperience(recommendationBannerHTML)}
            </div>
          </Col>
          <Col
            className="recommendation-listview"
            colSize={{ small: 6, medium: 8, large: 9 }}
            offsetLeft={{
              small: 0,
              medium: 0,
              large: 0,
            }}
            offsetRight={{
              small: 0,
              medium: 0,
              large: 0,
            }}
          >
            <Carousel
              className={`${variation}-variation`}
              options={carProps}
              inheritedStyles={Carousel}
              carouselConfig={{
                variation: CarouselVariation,
                customArrowLeft: CarouselcustomArrowLeft,
                customArrowRight: CArouselcustomArrowRight,
                dataLocatorCarousel: `${variation}-variation`,
              }}
              isNoResponseRecommendation={isNoResponseRecommendation}
            >
              {this.loadVariation(variation)}
            </Carousel>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  loadRecommendationVariation = (variation, product, index, itemClassName) => {
    const {
      products,
      className,
      loadedProductCount,
      onPickUpOpenClick,
      currency,
      currencyAttributes,
      onQuickViewOpenClick,
      page,
      portalValue,
      priceOnly,
      isDynamicBadgeEnabled,
      starRatingSize,
      moduleOHeaderLabel,
      isNewPDPEnabled,
      isBagPage,
      bagItemCount,
      isSNJEnabled,
      isRecommendationProductInfoEnabled,
      trackAnalyticsClick,
      isHideOriginalPriceAndMarchantTagEnabled,
      ...otherProps
    } = this.props;
    const { generalProductId, productInfo: { tcpStyleQty, tcpStyleType } = {} } = product;
    const priceOnlyClass = priceOnly ? 'price-only' : '';
    const isPromoAvailable = this.isPromoAvailable(products);
    return (
      <RecommendationComponentVariation
        key={`recommended_products_${variation}_${generalProductId}`}
        loadedProductCount={loadedProductCount}
        generalProductId={generalProductId}
        item={product}
        isPerfectBlock
        productsBlock={product}
        onPickUpOpenClick={onPickUpOpenClick}
        onQuickViewOpenClick={onQuickViewOpenClick}
        className={`${className} product-list ${priceOnlyClass}`}
        labels={this.labels}
        starRatingSize={starRatingSize}
        sequenceNumber={index + 1}
        variation={variation}
        currencySymbol={currency}
        currencyExchange={currencyAttributes.exchangevalue}
        currencyAttributes={currencyAttributes}
        viaModule={RECOMMENDATION}
        page={page}
        isPromoAvailable={isPromoAvailable}
        itemClassName={itemClassName}
        portalValue={portalValue}
        isDynamicBadgeEnabled={isDynamicBadgeEnabled}
        tcpStyleQty={tcpStyleQty}
        tcpStyleType={tcpStyleType}
        moduleOHeaderLabel={moduleOHeaderLabel}
        isNewPDPEnabled={isNewPDPEnabled}
        isBagPage={isBagPage}
        bagItemCount={bagItemCount}
        isSNJEnabled={isSNJEnabled}
        isRecommendationProductInfoEnabled={isRecommendationProductInfoEnabled}
        isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
        trackAnalyticsClick={trackAnalyticsClick}
        lazyLoadImage
        {...otherProps}
      />
    );
  };

  checkingProductCount = (showProducts, products) => {
    if (
      showProducts?.length === 0 ||
      (showProducts?.length !== products?.length && products?.length < viewProducts) ||
      (showProducts?.length < viewProducts && showProducts?.length < products?.length)
    )
      return true;
    return false;
  };

  loadVariationNew = (variation) => {
    const { products, portalValue, isSNJEnabled, isNewPDPEnabled } = this.props;
    const { showProducts, viewMoreProducts, showPdpProducts } = this.state;

    if (!isEqual(products, viewMoreProducts)) {
      if (products?.length > 0 && showPdpProducts > 0) {
        if (portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED)
          setSessionStorage({ key: 'PDP2', value: showPdpProducts });
        else setSessionStorage({ key: 'PDP1', value: showPdpProducts });
      }
      this.setState({ showProducts: [], viewMoreProducts: products });
    }

    if (
      this.labels &&
      this.labels.addToBag &&
      typeof this.labels.addToBag === 'object' &&
      this.labels.addToBag !== null
    )
      return null;

    if (this.checkingProductCount(showProducts, products)) this.showMoreProducts();
    const recos =
      portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED ? 'pdp2' : 'pdp1';
    setLocalStorage({
      key: recos,
      value: showProducts?.length > viewProducts ? showProducts?.length : 0,
    });

    return (
      <React.Fragment>
        <RecommendationUl snjNewPdpRecos={isSNJEnabled && isNewPDPEnabled}>
          {showProducts.map((product, index) => {
            const { generalProductId } = product;
            return (
              <RecommendationLi key={`recommended_products_li_${variation}_${generalProductId}`}>
                {this.loadRecommendationVariation(
                  variation,
                  product,
                  index,
                  'recommended_products_ul'
                )}
              </RecommendationLi>
            );
          })}
        </RecommendationUl>
        {products?.length !== showProducts?.length && this.showMoreButton()}
      </React.Fragment>
    );
  };

  checkIfMultiGridRecs = (portalValue, products) => {
    if (
      products &&
      products.length > 0 &&
      (portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.IN_GRID_PLP_PRODUCTS ||
        portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.IN_MULTI_GRID_PLP_PRODUCTS)
    ) {
      return true;
    }
    return false;
  };

  getHeaderLabelabel = () => {
    const { variation, page, moduleOHeaderLabel, modulePHeaderLabel } = this.props;
    let headerLabel =
      variation === config.variations.moduleO ? moduleOHeaderLabel : modulePHeaderLabel;
    if (page === Constants.RECOMMENDATIONS_PAGES_MAPPING.ADDED_TO_BAG) {
      headerLabel = capitalizeWords(headerLabel);
    }
    return headerLabel;
  };

  loadVariation(variation, itemClassName = '') {
    const {
      products,
      currency,
      currencyAttributes,
      styleWithView,
      portalValue,
      getRecommendationProducts,
      addToBagError,
      addToBagErrorId,
      styleHeaderLabel,
      isFBTEnabled,
      headerLabel,
      addedToBagData,
      updateFbtStatus,
      addToBagFbtError,
      isFBTDisplayed,
      isVerticalRecommendationsEnabled,
      ...otherProps
    } = this.props;
    getRecommendationProducts(products);
    if (
      this.labels &&
      this.labels.addToBag &&
      typeof this.labels.addToBag === 'object' &&
      this.labels.addToBag !== null
    )
      return null;
    if (this.haveFBTProducts(isFBTEnabled, products)) {
      const product = products[0];
      const { generalProductId } = product;
      const styleWithData = product.styleWithData && product.styleWithData.product;
      return styleWithData ? (
        <RecomFBT
          generalProductId={generalProductId}
          productItem={styleWithData}
          labels={this.labels}
          variation={variation}
          currencySymbol={currency}
          currencyExchange={currencyAttributes.exchangevalue}
          plpLabels={this.plpLabels}
          addToBagError={addToBagFbtError}
          addToBagErrorId={addToBagErrorId}
          portalValue={portalValue}
          headerLabel={headerLabel}
          addedToBagData={addedToBagData}
          updateFbtStatus={updateFbtStatus}
          isFBTDisplayed={isFBTDisplayed}
          {...otherProps}
        />
      ) : null;
    }

    if (this.haveStyleWithProducts(styleWithView, products)) {
      const product = products[0];
      const { generalProductId } = product;
      const styleWithData = product.styleWithData && product.styleWithData.product;
      return styleWithData ? (
        <RecomStyleWith
          generalProductId={generalProductId}
          productItem={styleWithData}
          labels={this.labels}
          variation={variation}
          currencySymbol={currency}
          currencyExchange={currencyAttributes.exchangevalue}
          plpLabels={this.plpLabels}
          addToBagError={addToBagError}
          addToBagErrorId={addToBagErrorId}
          portalValue={portalValue}
          styleHeaderLabel={styleHeaderLabel}
          {...otherProps}
        />
      ) : null;
    }

    return products.map((product, index) => {
      return this.loadRecommendationVariation(variation, product, index, itemClassName);
    });
  }

  handleAccordionToggle() {
    const { isAccordionOpen } = this.state;
    this.setState({ isAccordionOpen: !isAccordionOpen });
  }

  handleRecosHeightToggle() {
    const { isRecoHeightSmall } = this.state;
    this.setState({ isRecoHeightSmall: !isRecoHeightSmall });
  }

  renderItemList = (products, variation, carouselProps, showPeek, customProductsLength) => {
    const {
      newRecommendationEnabled,
      isBannerRecommendation,
      isNoResponseRecommendation,
      isVerticalRecommendationsEnabled,
      isPDP,
      isRecommendationSidebar,
      isRecommendationProductInfoEnabled,
      cartItemsCount,
      isBagPage,
      bagItemCount,
      isHomePage,
    } = this.props;
    const isMobileOrTablet = isClient()
      ? getViewportInfo().isMobile || getViewportInfo().isTablet
      : null;
    const minProductsLength = customProductsLength || productsLength;
    if (isBannerRecommendation) {
      return products?.length > 0
        ? this.loadBannerRecommendation(variation, carouselProps, customProductsLength)
        : null;
    }
    if (newRecommendationEnabled) return this.loadVariationNew(variation);
    let isEmptyBag = !(cartItemsCount && cartItemsCount > 0);
    isEmptyBag = bagItemCount && bagItemCount > 0 ? false : isEmptyBag;
    const CarouselView = isPDP || isHomePage || isBagPage ? CarouselContainer : Carousel;
    let minHeightClass = '';
    if (isBagPage) {
      minHeightClass = 'carousel-min-height-bag';
      minHeightClass = !isEmptyBag ? minHeightClass : `carousel-min-height-emptybag`;
    }
    if (products?.length >= minProductsLength || isVerticalRecommendationsEnabled) {
      return isMobileOrTablet || isVerticalRecommendationsEnabled ? (
        <div className={`smooth-scroll-list ${minHeightClass}`}>
          {this.loadVariation(variation, 'smooth-scroll-list-item')}
        </div>
      ) : (
        <CarouselView
          className={`${variation}-variation ${minHeightClass}`}
          options={carouselProps}
          inheritedStyles={Carousel}
          carouselConfig={{
            variation: 'big-arrows',
            customArrowLeft: getIconPath('carousel-big-carrot-left'),
            customArrowRight: getIconPath('carousel-big-carrot'),
            dataLocatorCarousel: `${variation}-variation`,
          }}
          isNoResponseRecommendation={isNoResponseRecommendation}
          isPDP={isPDP}
          isRecommendationSidebar={isRecommendationSidebar}
          isRecommendationProductInfoEnabled={isRecommendationProductInfoEnabled}
        >
          {this.loadVariation(variation)}
        </CarouselView>
      );
    }
    return (
      <div className={`no-carousel-container ${variation}-variation`}>
        {this.loadVariation(variation)}
      </div>
    );
  };

  getHeaderLabelabel = () => {
    const {
      variation,
      page,
      moduleOHeaderLabel,
      modulePHeaderLabel,
      searchNoResultRecommendation,
      headerLabelNoSearchResult,
    } = this.props;
    if (searchNoResultRecommendation) {
      return headerLabelNoSearchResult;
    }
    let headerLabel =
      variation === config.variations.moduleO ? moduleOHeaderLabel : modulePHeaderLabel;
    if (page === Constants.RECOMMENDATIONS_PAGES_MAPPING.ADDED_TO_BAG) {
      headerLabel = capitalizeWords(headerLabel);
    }
    return headerLabel;
  };

  renderRecommendationView(variation) {
    const {
      products,
      priceOnly,
      showButton,
      ctaText,
      ctaTitle,
      ctaUrl,
      carouselConfigProps,
      headerAlignment,
      isFavoriteRecommendation,
      isSuggestedItem,
      accordionHeader,
      showHeightToggle,
      showPeek,
      getRecommendationProducts,
      newRecommendationEnabled,
      portalValue,
      newBag,
      isNewPDPEnabled,
      outOfStock,
      isSNJEnabled,
      isATBModalBackAbTestNewDesign,
      searchNoResultRecommendation,
      isNoResponseRecommendation,
      page,
      isRedesignedPdpDesktopView,
      isNewPJPPDPRedesignEnabled,
      fromBIACarousel,
    } = this.props;

    let { customProductsLength } = this.props;
    getRecommendationProducts(products);

    const { isAccordionOpen, isRecoHeightSmall } = this.state;

    const priceOnlyClass = priceOnly ? 'price-only' : '';
    const params = config.params[variation];
    const headerLabel = this.getHeaderLabelabel();
    const carouselOptionsFinal = { ...config.CAROUSEL_OPTIONS };
    if (isSNJEnabled && isNewPDPEnabled) {
      carouselOptionsFinal.slidesToShow = 5;
      carouselOptionsFinal.slidesToScroll = 5;
    }

    if (
      page === Constants.RECOMMENDATIONS_PAGES_MAPPING.PDP &&
      isRedesignedPdpDesktopView &&
      isClient()
    ) {
      if (getViewportInfo().isLargeDesktop) {
        carouselOptionsFinal.slidesToShow = 6;
        carouselOptionsFinal.slidesToScroll = 6;
        customProductsLength = 6;
      } else if (
        isNewPJPPDPRedesignEnabled &&
        getViewportInfo().width >= parseInt(breakpoints.xlarge, 10)
      ) {
        carouselOptionsFinal.slidesToShow = 5;
        carouselOptionsFinal.slidesToScroll = 5;
        customProductsLength = 5;
      }
    }
    const carouselProps = {
      ...carouselOptionsFinal,
      ...carouselConfigProps,
      adaptiveHeight: false,
    };
    const showHeader = isShowHeader(
      isFavoriteRecommendation,
      isSuggestedItem,
      accordionHeader,
      portalValue
    );
    const accordionToggleClass = this.getAccordionClass(isAccordionOpen);
    const heightToggleClass = this.getRecoHeightStatus(isRecoHeightSmall);

    if (this.checkIfMultiGridRecs(portalValue, products))
      return this.loadInMultiGridPlpRecommendation(variation);
    return (
      products &&
      products.length > 0 && (
        <div
          className={`${
            (isNewPDPEnabled && !outOfStock) ||
            (isNewPDPEnabled && isSNJEnabled) ||
            searchNoResultRecommendation ||
            isNoResponseRecommendation
              ? 'recommendations-container-new'
              : 'recommendations-container'
          }${searchNoResultRecommendation ? ' search-no-result-recommendations' : ''}`}
        >
          {accordionHeader && (
            <BodyCopy
              className={`accordion-recommendation ${priceOnlyClass} ${accordionToggleClass}`}
              fontSize="fs14"
              component="div"
              fontFamily="secondary"
              fontWeight="black"
              onClick={this.handleAccordionToggle}
              id="recommendation"
            >
              {headerLabel}
            </BodyCopy>
          )}
          {showHeader && !fromBIACarousel && (
            <Heading
              variant="h4"
              className={`recommendations-header ${priceOnlyClass}`}
              textAlign={headerAlignment || 'center'}
              dataLocator={params?.dataLocator || ''}
              id={
                newRecommendationEnabled &&
                `recommendation${headerLabel ? headerLabel.split(' ').join('') : ''}`
              }
            >
              {headerLabel}
            </Heading>
          )}
          {showHeightToggle && <div className={`${heightToggleClass}-val`} />}
          <Row
            fullBleed
            className={`recommendations-section-row ${
              isNewPDPEnabled && isSNJEnabled ? 'recommendation-hide-border' : ''
            }`}
          >
            <RecommendationCol
              showPeek={showPeek}
              newRecommendationEnabled={newRecommendationEnabled}
              className="recommendations-section-col"
              colSize={{
                small: 6,
                medium: 8,
                large: 10,
              }}
              offsetLeft={{
                small: 0,
                medium: 0,
                large: 1,
              }}
            >
              {this.renderItemList(
                products,
                variation,
                carouselProps,
                showPeek,
                customProductsLength
              )}
            </RecommendationCol>
          </Row>
          {showButton && (
            <div className="recommendation-cta-container">
              <ButtonCTA
                className="recommendation-cta"
                uniqueKey="recommendation-button"
                dataLocator={{
                  cta: params?.dataLocatorCTA,
                }}
                ctaInfo={{
                  ctaVariation: 'fixed-width',
                  link: {
                    url: ctaUrl,
                    title: ctaTitle,
                    text: ctaText,
                  },
                }}
                newBag={newBag}
              />
            </div>
          )}
          {showHeightToggle && (
            <BodyCopy
              className={`recommendation-height-toggle ${heightToggleClass}`}
              fontSize="fs14"
              component="div"
              fontFamily="secondary"
              fontWeight="black"
              onClick={this.handleRecosHeightToggle}
              id="recommendation-height"
            />
          )}
        </div>
      )
    );
  }
  renderRecommendationComponentView = (
    carouselConfigProps,
    products,
    variation,
    className,
    spcBag
  ) => {
    return (
      <div
        className={`recommendation-container ${
          products?.length > 4 && carouselConfigProps?.slidesToShow > 5
            ? 'many-item-recommendation-non-empty-bag'
            : ''
        }`}
      >
        {variation?.map((value, index) => {
          return (
            <section
              className={`${className} recommendations-tile ${getSFCCClass(spcBag)}`}
              key={`recommendation-container-tile_${index.toString()}`}
            >
              {this.renderRecommendationView(value)}
            </section>
          );
        })}
      </div>
    );
  };

  render() {
    const {
      className,
      variations,
      ariaPrevious,
      ariaNext,
      reduxKey,
      styleWithView,
      products,
      isLoading,
      spcBag,
      carouselConfigProps,
      isSNJEnabled,
      isNewPDPEnabled,
      isFBTEnabled,
      isProductLoading,
      isPDP,
      isBagPage,
      isRecommendationCarouselRedesignEnabled,
      recommendationCarouselRedesign,
      isHomePage,
      isOutFitPage,
      sequence,
      isTrendingInCategoryRecommendations,
      onQuickViewOpenClick,
      isHideOriginalPriceAndMarchantTagEnabled,
      isDynamicBadgeEnabled,
      currencySymbol,
      currencyAttributes,
      isTrendingInCategoryRecommendationsDisplayBadgeEnabled,
      isDynamicBadgeEnabledAbtest,
    } = this.props;
    const showSkeletonWithLazyLoad = isPDP || isBagPage || isHomePage || isOutFitPage;
    const isMobile = isClient() ? getViewportInfo().isMobile : false;
    const offset = isMobile ? 200 : 400;

    if (isTrendingInCategoryRecommendations) {
      return (
        <TrendingInCategoryRecommendations
          products={products}
          onQuickViewOpenClick={onQuickViewOpenClick}
          isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
          isDynamicBadgeEnabled={isDynamicBadgeEnabled}
          currencySymbol={currencySymbol}
          currencyAttributes={currencyAttributes}
          isTrendingInCategoryRecommendationsDisplayBadgeEnabled={
            isTrendingInCategoryRecommendationsDisplayBadgeEnabled
          }
        />
      );
    }

    if (!Array.isArray(products)) {
      return showSkeletonWithLazyLoad ? (
        <div className="hide-skeleton-largeDesktop">
          {<RecommendationSkeleton {...this.props} />}
        </div>
      ) : (
        <></>
      );
    }

    if (isRecommendationCarouselRedesignEnabled && recommendationCarouselRedesign) {
      return showSkeletonWithLazyLoad ? (
        <LazyLoadHOC
          id={`recommendation-lazy-load-${sequence}`}
          offset={offset}
          loadingComponent={<RecommendationSkeleton {...this.props} />}
        >
          <RecommendationCarousel {...this.props} />
        </LazyLoadHOC>
      ) : (
        <RecommendationCarousel {...this.props} />
      );
    }

    if (isClient() && getViewportInfo().isDesktop && isNewPDPEnabled && isSNJEnabled) {
      viewProducts = 10;
    }
    config.CAROUSEL_OPTIONS.prevArrow = (
      <button
        type="button"
        aria-label={ariaPrevious}
        data-locator="moduleO_left_arrow"
        className="slick-prev"
        tabIndex="0"
      />
    );
    config.CAROUSEL_OPTIONS.nextArrow = (
      <button
        type="button"
        aria-label={ariaNext}
        data-locator="moduleO_right_arrow"
        className="slick-prev"
        tabIndex="0"
      />
    );

    const variation = variations.split(',');

    if (reduxKey === 'favorites_global_products') {
      return variation.map((value, index) => {
        const recVal = this.renderRecommendationView(value);
        const recClass = recVal ? 'recommendation-container full' : 'recommendation-container';
        return (
          <div className={recClass} key={`recommendation_tile_fgp_${index.toString()}`}>
            <section className={`${className} recommendations-tile`}>{recVal}</section>
          </div>
        );
      });
    }
    if (this.haveFBTProducts(isFBTEnabled, products)) {
      return <>{this.loadVariation('FBT')}</>;
    }

    if (this.haveStyleWithProducts(styleWithView, products)) {
      return <>{this.loadVariation('styleWith')}</>;
    }

    return showSkeletonWithLazyLoad ? (
      <LazyLoadHOC
        id={`recommendation-lazy-load-${sequence}`}
        offset={offset}
        loadingComponent={<RecommendationSkeleton {...this.props} />}
      >
        {this.renderRecommendationComponentView(
          carouselConfigProps,
          products,
          variation,
          className,
          spcBag
        )}
      </LazyLoadHOC>
    ) : (
      this.renderRecommendationComponentView(
        carouselConfigProps,
        products,
        variation,
        className,
        spcBag
      )
    );
  }
}

Recommendations.propTypes = {
  loadRecommendationsAdobe: func.isRequired,
  loadRecommendationsMonetate: func.isRequired,
  moduleOHeaderLabel: string.isRequired,
  modulePHeaderLabel: string.isRequired,
  products: arrayOf(oneOfType(shape({}))).isRequired,
  className: string.isRequired,
  isPlcc: bool,
  loadedProductCount: number,
  onPickUpOpenClick: func.isRequired,
  priceOnly: bool,
  showButton: bool,
  ctaText: string,
  ctaTitle: string,
  ctaUrl: string,
  variations: string,
  currency: string,
  currencyAttributes: shape({ exchangevalue: number }),
  onQuickViewOpenClick: func.isRequired,
  page: string,
  portalValue: string,
  carouselConfigProps: shape({}),
  partNumber: string,
  categoryName: string,
  headerAlignment: string,
  reduxKey: string.isRequired,
  ariaPrevious: string,
  ariaNext: string,
  isFavoriteRecommendation: bool,
  isSuggestedItem: bool,
  router: shape({}),
  excludedIds: string,
  accordionHeader: bool,
  showHeightToggle: bool,
  showPeek: shape({}),
  starRatingSize: shape({}),
  customProductsLength: number,
  hasSuggestedProduct: bool,
  provider: string.isRequired,
  MONETATE_ENABLED: bool,
  cartItems: arrayOf(shape({})),
  isBagLoading: bool,
  isOutfitLoading: bool,
  outfitItems: arrayOf(shape({})),
  styleWithView: bool,
  headerLabel: string,
  userEmail: string,
  newRecommendationEnabled: bool,
  addedToBagData: shape({}),
  pdpDataInformation: shape({}),
  getRecommendationProducts: func,
  addToBagError: string,
  addToBagErrorId: string,
  styleHeaderLabel: string,
  styleWithEligibility: bool,
  isBannerRecommendation: bool,
  recommendationBannerHTML: string,
  outOfStock: bool,
  isLoading: bool,
  isProductLoading: bool,
  isDynamicBadgeEnabled: shape({}),
  index: number,
  slots: arrayOf(shape({})),
  slotsList: arrayOf(shape({})),
  inGridPlpRecommendation: bool,
  isNewPDPEnabled: bool,
  spcBag: bool,
  newBag: bool,
  isBagPage: bool,
  isATBModalBackAbTestNewDesign: bool,
  bagItemCount: bool,
  isSNJEnabled: bool,
  isNoResponseRecommendation: bool,
  categoryFilterArray: string,
  isRedesignedPdpDesktopView: bool,
  isPDP: bool,
  isRecommendationSidebar: bool,
  isCrossBrandMerchandisingEnabled: bool,
  isRecommendationMarginEnabled: bool,
  isNewPJPPDPRedesignEnabled: bool,
  birthdayDepartment: string,
  trackAnalyticsClick: func,
};

Recommendations.defaultProps = {
  priceOnly: false,
  showButton: false,
  ctaText: '',
  ctaTitle: '',
  ctaUrl: '',
  variations: '',
  currency: 'USD',
  currencyAttributes: {
    exchangevalue: 1,
  },
  page: '',
  portalValue: '',
  carouselConfigProps: null,
  partNumber: '',
  categoryName: '',
  headerAlignment: '',
  ariaPrevious: '',
  ariaNext: '',
  isFavoriteRecommendation: false,
  isSuggestedItem: false,
  excludedIds: '',
  accordionHeader: false,
  showHeightToggle: false,
  showPeek: { small: false, medium: false },
  starRatingSize: { small: 72, large: 100 },
  customProductsLength: 0,
  hasSuggestedProduct: false,
  MONETATE_ENABLED: true,
  cartItems: [],
  isBagLoading: false,
  isOutfitLoading: false,
  outfitItems: [],
  styleWithView: false,
  headerLabel: null,
  isPlcc: false,
  userEmail: '',
  newRecommendationEnabled: false,
  addedToBagData: {},
  getRecommendationProducts: () => {},
  addToBagError: '',
  addToBagErrorId: '',
  styleHeaderLabel: '',
  styleWithEligibility: false,
  isBannerRecommendation: false,
  recommendationBannerHTML: '</>',
  outOfStock: false,
  isDynamicBadgeEnabled: false,
  index: 0,
  slots: [],
  slotsList: [],
  inGridPlpRecommendation: false,
  spcBag: false,
  isNewPDPEnabled: false,
  newBag: false,
  isBagPage: false,
  isATBModalBackAbTestNewDesign: false,
  bagItemCount: false,
  isSNJEnabled: false,
  loadedProductCount: undefined,
  router: undefined,
  pdpDataInformation: undefined,
  isLoading: false,
  isProductLoading: false,
  isNoResponseRecommendation: false,
  categoryFilterArray: '',
  isRedesignedPdpDesktopView: false,
  isPDP: false,
  isRecommendationSidebar: false,
  isCrossBrandMerchandisingEnabled: bool,
  isRecommendationMarginEnabled: false,
  isNewPJPPDPRedesignEnabled: false,
  birthdayDepartment: '',
  trackAnalyticsClick: () => {},
};
export { Recommendations as RecommendationsVanilla };

export default errorBoundary(withStyles(Recommendations, style));
